import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  mobileTip: {
    background: theme.palette.brand.greyMid,
    boxShadow: 'none',
  },
  summary: { fontWeight: 'bold', textAlign: 'left' },
  expandIcon: { color: 'black' },
  tipDetails: { textAlign: 'left' },
}));

interface Props {
  summary: string;
  details: string;
}

export default function MobileTip({ summary, details }: Props) {
  const classes = useStyles();

  return (
    <Accordion className={classes.mobileTip}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
      >
        <Typography className={classes.summary}> {summary}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.tipDetails}>
        <Typography>{details}</Typography>
      </AccordionDetails>
    </Accordion>
  );
}
